import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useBrowser, useShouldLogOut } from 'hooks';
import { AUTH_ERROR } from 'utils/constants';
import { Loader } from 'components/loader/Loader';
import { SignOutForm } from 'components/signout-form';
import { authErrorSelector } from 'modules/admin-panel/selectors/auth/authErrorSelector';

interface MainProps {
	isLoading?: boolean;
	isAuthenticated: boolean;
	header: React.ElementType;
	navbar: React.ElementType;
}

export const Main: React.FC<MainProps> = ({
	isLoading,
	isAuthenticated,
	children,
	header: Header,
	navbar: NavBar,
}) => {
	const { isIE } = useBrowser();
	const error = useSelector(authErrorSelector);
	const { shouldLogOut, setShouldLogOut } = useShouldLogOut();

	useEffect(() => {
		if (error?.message === AUTH_ERROR) {
			setShouldLogOut(true);
		}
	}, [error]);

	return (
		<Loader isLoading={isLoading}>
			<SignOutForm shouldLogOut={shouldLogOut} hide />
			{isAuthenticated ? (
				<div
					className={`app-wrapper app-wrapper--column ${
						isIE ? 'app-wrapper__IE' : ''
					}`}
				>
					<Header />
					<div className="private-wrapper">
						<NavBar />
						{children}
					</div>
				</div>
			) : null}
		</Loader>
	);
};
